var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"section-card"},[_c('img',{staticClass:"card-image",attrs:{"src":_vm.imgSrc,"alt":_vm.imgAlt}}),_c('div',{staticClass:"textos"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }